<template>
  <div>
    <ul class="tab">
      <li :class="{'active':activeTab === 0}" @click="activeTab = 0">
        Profile History
      </li>
      <li :class="{'active':activeTab === 1}" @click="activeTab = 1">
        Activity History
      </li>
    </ul>

    <div class="tab-contents">
      <div :class="{'tab-content':true, 'active':activeTab === 0}" @scroll="onScrollProfile">
        <select v-model="profileHistoryDate" :disabled="profileHistoryLoading" :class="{'date-select':true, 'disabled':profileHistoryLoading}">
          <option value="all">All</option>
          <option value="custom">Custom</option>
        </select>
        <profile-history ref="profileHistory"></profile-history>
      </div>
      <div :class="{'tab-content':true, 'active':activeTab === 1}" @scroll="onScrollActivity">
        <select v-model="activityHistoryDate" :disabled="activityHistoryLoading" :class="{'date-select':true, 'disabled':activityHistoryLoading}">
          <option value="all">All</option>
          <option value="custom">Custom</option>
        </select>
        <activity-history ref="activityHistory"></activity-history>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileHistory from './ProfileHistory'
import ActivityHistory from './ActivityHistory'

export default {
  name: 'logs',
  components: { ProfileHistory, ActivityHistory },
  data () {
    return {
      activeTab: 0,
      profileHistoryDate: 'all',
      activityHistoryDate: 'all'
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    profileHistoryLoading () { return this.$store.state.provider.logs.profileHistory.loading },
    activityHistoryLoading () { return this.$store.state.provider.logs.activityHistory.loading }
  },
  methods: {
    onScrollProfile (value) {
      if (this.$refs.profileHistory.onScroll(value)) {
        this.$refs.profileHistory.onScroll(value)
      }
    },
    onScrollActivity (value) {
      if (this.$refs.activityHistory.onScroll(value)) {
        this.$refs.activityHistory.onScroll(value)
      }
    },
    reload () {
      if (this.$refs.profileHistory.init()) {
        this.$refs.profileHistory.init()
      }
    }
  },
  watch: {
    provId: function (value) {
      this.showLogs = false
      this.profileHistoryDate = 'all'
      this.activityHistoryDate = 'all'
    },
    profileHistoryDate: function (value) {
      if (this.$refs.profileHistory.dateToggle(value)) {
        this.$refs.profileHistory.dateToggle(value)
      }
    },
    activityHistoryDate: function (value) {
      if (this.$refs.activityHistory.dateToggle(value)) {
        this.$refs.activityHistory.dateToggle(value)
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.tab{
  list-style: none;
  padding: 0;
  margin: 15px 0 0;
  display: flex;
  position: relative;
  z-index: 2;

  li{
    color: #0D79F2;
    padding: 15px 25px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    cursor: pointer;

    &.active{
      background: #fff;
      box-shadow: 0 -1px 2px rgba(0,0,0, .1);
      border-radius: 2px 2px 0 0;
      color: #777;
    }
  }
}

.tab-contents{
  background: #fff;
  z-index: 1;
  position: relative;
  box-shadow: 0 0 2px 1px rgba(0,0,0, .1);

  .tab-content{
    padding: 20px;
    display: none;
    height: calc(100vh - 65px);
    overflow: auto;

    &.active{ display: block; }
  }
}

@media only screen and (max-width: 430px) {
  .tab {
    margin-top: 60px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Provider/Logs.vue